import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { VideoModal } from '@zola/zola-ui';

import { hideModal, hideSecondaryModal, showModal } from '../../actions/ModalActions';
import AuthModal from './auth/AuthModal';
import WeddingPartyMemberForm from '../manage/website/entities/WeddingPartyMemberForm';
import FaqForm from '../manage/website/entities/FaqForm';
import PoiForm from '../manage/website/entities/PoiForm';
import TravelForm from '../manage/website/entities/TravelForm';
import HomepageSectionForm from '../manage/website/entities/HomepageSectionForm';
import RegistryForm from '../manage/website/entities/RegistryForm';
import RegistryFormv2 from '../manage/website/entities/RegistryFormv2';
import EditChecklistForm from '../manage/checklist/EditChecklistForm';
import AddTaskForm from '../manage/checklist/AddTaskForm';
import CropModal from '../manage/website/entities/CropModal';
import PhotoForm from '../manage/website/entities/PhotoForm';
import { WebsiteOnboardSuccessModalContainer } from '../onboard/WebsiteOnboard';
import GuestMessageModal from '../manage/guestlist/GuestMessageModal';
import DeleteGuestGroupModal from '../manage/guestlist/DeleteGuestGroupModal';
import ShareModal from './ui/ShareModal';
import DeleteChecklistModal from '../manage/checklist/DeleteTaskModal';
import DeleteEntityModal from '../manage/website/DeleteEntityModal';
import DeletePhotoModal from '../manage/website/DeletePhotoModal';
import RegistryItemModal from '../registryitem/RegistryItem';
import CartModal from '../cart/CartModal';
import PublishWebsiteModalv2 from '../manage/website/PublishWebsiteModalv2';
import PublishRegistryModalv3 from '../manage/website/PublishRegistryModalv3';
import PublishPageErrorModal from '../manage/website/PublishPageErrorModal';
import DidntBuyModal from '../registryitem/DidntBuyModal';
import PublishRsvpModal from '../manage/website/PublishRsvpModal';
import SetShippingAddressModal from '../manage/common/SetShippingAddressModal';
import RequestMissingInfoModalV2 from './modals/RequestMissingInfoModal/RequestMissingInfoModal';
import AboutZolaModal from '../registry/AboutZolaModal';
import AboutZolaModalv2 from '../registry/AboutZolaModalV2';
import ReorderPagesModal from '../manage/website/ReorderPagesModal';
import WebsiteSettingsModal from '../manage/website/WebsiteSettingsModal';
import HidePagesModal from '../manage/common/HidePagesModal';
import EventFormModal from '../manage/common/EventFormModal';
import DeleteEventModal from '../manage/events/components/DeleteEventModal';
import AddGuestGroupModalV2 from '../manage/guestlist/AddGuestGroupModalV2';
import EditGuestGroupModalWedding from './modals/EditGuestGroupWeddingsModal/EditGuestGroupWeddingsModal';
import CheckGuestDuplicatesModal from '../manage/guestlist/CheckGuestDuplicatesModal';
import MultipleEventsModal from './modals/MultipleEventsModal/MultipleEventsModal';
import EditTaskFormModal from './modals/EditTaskFormModal/EditTaskFormModal';
import MultipleEventsMigrationModal from './modals/MultipleEventsMigrationModal/MultipleEventsMigrationModal';
import BulkUninviteConfirmationModal from './modals/BulkUninviteConfirmationModal/BulkUninviteConfirmationModal';
import UninviteGuestConfirmationModal from './modals/UninviteGuestConfirmationModal/UninviteGuestConfirmationModal';
import ConfirmActionModal from './modals/ConfirmActionModal/ConfirmActionModal';
import CustomDomainModal from './modals/CustomDomainModal/CustomDomainModal';
import AcknowledgeUpdateModal from '../settings/url/modal/AcknowledgeUpdateModal';
import CustomDomainCompletionModal from './modals/CustomDomainModal/CustomDomainCompletionModal';
import DeclineRsvpRequestModal from './modals/DeclineRsvpRequestModal/DeclineRsvpRequestModal';
import EditGuestGroupModal from './modals/EditGuestGroupModal/EditGuestGroupModal';
import NewTableModal from '../manage/seatingchart/seatingChartModals/NewTableModal';
import EditTableModal from '../manage/seatingchart/seatingChartModals/EditTableModal';
import DeleteTableModal from '../manage/seatingchart/seatingChartModals/DeleteTableModal';
import InvitesRedirectModalVA from './modals/InvitesRedirectModal/InvitesRedirectModalVA';
import InvitesRedirectModalVB from './modals/InvitesRedirectModal/InvitesRedirectModalVB';
import RsvpSuccessModal from '../PublicWebsite/pages/rsvp/RsvpSuccessModal/RsvpSuccessModal';

// invitations modals
import CancelOrderModal from '../../cards/components/common/modals/CancelOrderModal/CancelOrderModal';

const MODAL_COMPONENTS = {
  AUTH: AuthModal,
  PHOTO: PhotoForm,
  WEDDING_PARTY: WeddingPartyMemberForm,
  FAQ: FaqForm,
  POI: PoiForm,
  TRAVEL: TravelForm,
  HOMEPAGE_SECTION: HomepageSectionForm,
  WEBSITE_ONBOARD: WebsiteOnboardSuccessModalContainer,
  REGISTRY: RegistryForm,
  REGISTRYV2: RegistryFormv2,
  DELETE_GUEST_GROUP: DeleteGuestGroupModal,
  GUEST_MESSAGE: GuestMessageModal,
  CHECKLIST_EDIT: EditChecklistForm,
  CHECKLIST_TASK_ADD: AddTaskForm,
  DELETE_CHECKLIST_TASK: DeleteChecklistModal,
  DELETE_ENTITY: DeleteEntityModal,
  DELETE_PHOTO: DeletePhotoModal,
  CROP_MODAL: CropModal,
  SHARE: ShareModal,
  VIDEO: VideoModal,
  REGISTRY_ITEM: RegistryItemModal,
  CART_MODAL: CartModal,
  PUBLISH_WEBSITE: PublishWebsiteModalv2,
  PUBLISH_REGISTRY: PublishRegistryModalv3,
  PUBLISH_PAGE_ERROR: PublishPageErrorModal,
  DIDNT_BUY_MODAL: DidntBuyModal,
  PUBLISH_RSVP: PublishRsvpModal,
  SET_SHIPPING_ADDRESS: SetShippingAddressModal,
  REQUEST_MISSING_INFO_V2: RequestMissingInfoModalV2,
  ABOUT_ZOLA: AboutZolaModal,
  ABOUT_ZOLA_V2: AboutZolaModalv2,
  REORDER_PAGES: ReorderPagesModal,
  WEBSITE_SETTINGS: WebsiteSettingsModal,
  HIDE_PAGES: HidePagesModal,
  EVENT_FORM: EventFormModal,
  DELETE_EVENT: DeleteEventModal,
  ADD_GUEST_GROUP_V2: AddGuestGroupModalV2,
  EDIT_GUEST_GROUP_WEDDING: EditGuestGroupModalWedding,
  CHECK_GUEST_DUPLICATES: CheckGuestDuplicatesModal,
  MULTIPLE_EVENTS: MultipleEventsModal,
  MULTIPLE_EVENTS_MIGRATION: MultipleEventsMigrationModal,
  BULK_UNINVITE_CONFIRMATION: BulkUninviteConfirmationModal,
  UNINVITE_GUEST_CONFIRMATION: UninviteGuestConfirmationModal,
  CONFIRM_ACTION: ConfirmActionModal,
  CUSTOM_DOMAIN_MODAL: CustomDomainModal,
  ACKNOWLEDGE_UPDATE_MODAL: AcknowledgeUpdateModal,
  CUSTOM_DOMAIN_COMPLETION_MODAL: CustomDomainCompletionModal,
  INVITE_REDIRECT_MODAL_VARIATION_A: InvitesRedirectModalVA,
  INVITE_REDIRECT_MODAL_VARIATION_B: InvitesRedirectModalVB,
  RSVP_SUCCESS_MODAL: RsvpSuccessModal,
  /* other modals */
  DECLINE_RSVP_REQUEST: DeclineRsvpRequestModal,
  /* invitations modals */
  CANCEL_ORDER: CancelOrderModal,
  EDIT_GUEST_GROUP: EditGuestGroupModal,
  /* */
  EDIT_TASK_FORM: EditTaskFormModal,
  NEW_TABLE_MODAL: NewTableModal,
  EDIT_TABLE_MODAL: EditTableModal,
  DELETE_TABLE_MODAL: DeleteTableModal
};

class ModalRoot extends Component {
  constructor(props) {
    super(props);

    this.onBackgroundClick = this.onBackgroundClick.bind(this);
    this.onSecondaryBackgroundClick = this.onSecondaryBackgroundClick.bind(this);
    this.onEscape = this.onEscape.bind(this);
  }

  onShow() {
    if (document && document.body) {
      const orig = document.body.className;
      document.body.className = `${orig} modal-open`.trim();
    }
    document.addEventListener('keydown', this.onEscape);
  }

  onHide() {
    if (document && document.body) {
      document.body.className = document.body.className.replace(/ ?modal-open/g, '');
    }
    document.removeEventListener('keydown', this.onEscape);
  }

  onBackgroundClick(e) {
    const { modalProps, hideModalFn } = this.props;
    if (!modalProps.disableClose && e.target === e.currentTarget) {
      hideModalFn();
    }
  }

  onSecondaryBackgroundClick(e) {
    const { hideSecondaryModalFn } = this.props;
    if (e.target === e.currentTarget) {
      hideSecondaryModalFn();
    }
  }

  onEscape({ keyCode }) {
    const { modalProps } = this.props;
    if (!modalProps.disableClose && keyCode === 27) {
      this.props.hideModalFn();
    }
  }

  shouldLaunchWebNavModal() {
    // do not launch web-wedding modal if we are trying to sign up and web-nav is available
    const { modalType, modalProps } = this.props;
    return (modalType === MODAL_COMPONENTS.AUTH)
      && modalProps.authState === 'signup'
      && window.zolaNav
      && window.zolaNav.openSignupModal;
  }

  render() {
    const { modalType, modalProps, hideModalFn, hideSecondaryModalFn, modalOptions, secondaryModal, showModalFn } = this.props;
    if (!modalType) {
      this.onHide();
      return null;
    }
    if (!this.shouldLaunchWebNavModal()) {
      this.onShow();
    }
    const SpecificModal = MODAL_COMPONENTS[modalType];
    const SpecificSecondaryModal = MODAL_COMPONENTS[secondaryModal.modalType];
    return (
      <div>
        <div tabIndex="-1" role="dialog" className="modal in" style={{ zIndex: 1050, display: 'block' }} onClick={this.onBackgroundClick}>
          <div className={(`modal-dialog modal-${modalOptions && modalOptions.size ? modalOptions.size : 'lg'}`)}>
            <div className="modal-content">
              {!modalProps.hideClose && (
                <button type="button" className="modal-close" onClick={hideModalFn}>×</button>
              )}
              <SpecificModal {...modalProps} hideModalFn={hideModalFn} showModalFn={showModalFn} />
            </div>
          </div>
        </div>
        <div className="modal-backdrop in" />
        {SpecificSecondaryModal && (
          <div>
            <div tabIndex="-1" role="dialog" className="modal in" style={{ zIndex: 1060, display: 'block' }} onClick={this.onSecondaryBackgroundClick}>
              <div className={(`modal-dialog modal-${secondaryModal.modalOptions && secondaryModal.modalOptions.size ? secondaryModal.modalOptions.size : 'sm'}`)} style={{ margin: '60px auto' }}>
                <div className="modal-content">
                  {!secondaryModal.modalProps.hideClose && (
                    <button type="button" className="modal-close" onClick={hideSecondaryModalFn}>×</button>
                  )}
                  <SpecificSecondaryModal {...secondaryModal.modalProps} hideModalFn={hideSecondaryModalFn} showModalFn={showModalFn} />
                </div>
              </div>
            </div>
            <div className="modal-backdrop in" style={{ zIndex: '1055' }} />
          </div>
        )}
      </div>
    );
  }
}

ModalRoot.propTypes = {
  modalType: PropTypes.string,
  modalProps: PropTypes.shape({
    callback: PropTypes.func
  }),
  hideModalFn: PropTypes.func.isRequired,
  modalOptions: PropTypes.shape({}),
  secondaryModal: PropTypes.shape({}),
  hideSecondaryModalFn: PropTypes.func,
  showModalFn: PropTypes.func.isRequired,
};

const mapStateToProps = state => (
  state.modal
);

const mapDispatchToProps = {
  hideModalFn: hideModal,
  hideSecondaryModalFn: hideSecondaryModal,
  showModalFn: showModal
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalRoot);



// WEBPACK FOOTER //
// ./src/components/common/ModalRoot.jsx